import React from 'react';
import SearchField from './search-field';

const SearchBox = (props) => {
	return (
		<div className="box">
			<p className="title is-4 has-text-left">Ricerca</p>
			<SearchField onChangeInput={props.onChangeInput} placeholder="Cerca Immagine"/>
		</div>
	)
};

export default SearchBox


// WEBPACK FOOTER //
// ./src/components/search-box.jsx